<div class="issue-container">
  <button class="accordion" (click)="togglePanelView()" [ngClass]="{ expanded: panelDisplayed }">
    <div class="issue-type-accordion-title gap-8 full-width">
      <div class="issue-header-row">
        @if (!grouped) {
          <div class="issue-type">{{ issue.issue?.title ?? issue.issue.issueTypeDisplayString }}</div>
        }
        @if (grouped) {
          <div class="issue-type">
            {{ resourceTypeString || issue.issue?.title || issue.issue.issueTypeDisplayString }}
          </div>
        }
      </div>
      <div class="resource-id full-width">
        @if (resourceNameString) {
          <div class="resource-name-block">
            @if (!grouped && resourceNameString && resourceTypeString) {
              <span class="resource-type-label">{{ resourceTypeString }}: </span>
            }
            <span class="inline-copy-block">
              <span class="inline-copy-text">{{ resourceNameString }}</span>
            </span>
            @if (resourceNameString) {
              <button
                class="inline-copy-btn"
                [copy-clipboard]="resourceNameString"
                (copied)="onResourceNameCopied()"
                (click)="$event.stopPropagation()"
                aria-label="Copy resource name"
              >
                @if (copyFeedback.copiedStates['resource']) {
                  <svg lucideCheck class="copy-check"></svg>
                } @else {
                  <svg lucideCopy></svg>
                }
              </button>
            }
            @if (consoleUrl) {
              <a
                class="console-link-btn"
                href="{{ consoleUrl }}"
                target="_blank"
                rel="noopener"
                (click)="$event.stopPropagation()"
                [pTooltip]="'Open in ' + (application?.type === 'azure' ? 'Azure Portal' : 'AWS Console')"
                tooltipPosition="top"
              >
                <svg lucideExternalLink></svg>
              </a>
            }
          </div>
        } @else {
          <span class="no-resource-text">No associated resource</span>
        }
      </div>
    </div>
    <div id="expand-glyph">
      @if (panelDisplayed) {
        <svg lucideChevronUp></svg>
      } @else {
        <svg lucideChevronDown></svg>
      }
    </div>
  </button>
  <div class="accordion-panel" [@accordionSlide]="panelDisplayed ? 'expanded' : 'collapsed'">
    <issue-body [issue]="issue" [sync-pair]="syncPair" [application]="application"></issue-body>
    <div class="issue-id-container">Issue ID: {{ issue.issueId }}</div>
  </div>
</div>
